import { createAsyncThunk } from '@reduxjs/toolkit';
import labApi from '../../core/api/lab.api';
import { GetShipmentResponse } from '../../core/api/lab.types';

export const getShipmentThunk = createAsyncThunk(
  'shipment/getShipment',
  async (id: string, { rejectWithValue }: any) => {
    const response: GetShipmentResponse = await labApi.getShipment(id);

    if (response.data?.getShipment) {
      return response.data.getShipment;
    }

    return rejectWithValue(response.errors);
  },
);
